export default __webpack_public_path__ + "static/media/conflicto.58a0f787.png";